import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const SearchFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M10.33 3.39c-3.79 0-6.86 3.07-6.86 6.86 0 3.79 3.07 6.86 6.86 6.86 3.79 0 6.86-3.07 6.86-6.86 0-3.79-3.07-6.86-6.86-6.86Zm4.34 7.73c-.43 0-.77-.34-.77-.77 0-2.12-1.73-3.85-3.85-3.85-.43 0-.77-.34-.77-.77s.34-.77.77-.77c2.97 0 5.39 2.42 5.39 5.39 0 .43-.34.77-.77.77Z" />
      <Path d="m19.79 18.26-3.48-3.48c-.43.57-.94 1.07-1.5 1.49l3.49 3.49c.21.21.48.31.75.31s.54-.1.75-.31c.41-.41.41-1.08 0-1.5h-.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default SearchFilled
